import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=48ba1d6a&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=48ba1d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba1d6a",
  null
  
)

export default component.exports